import { eligibilityTooltipProps } from '~/pages/ContactsDashboard/ContactsDashboard.utils';
export function deleteTooltipProps(contact, isOnlyContact, lastContactTooltip, eligibilityTexts) {
    if (!contact.canDelete()) return eligibilityTooltipProps(contact.deleteEligibility(), 'delete', eligibilityTexts);
    if (isOnlyContact) return {
        title: lastContactTooltip,
        placement: 'bottom'
    };
    return undefined;
}
